// extracted by mini-css-extract-plugin
export default {"cardForm":"CardOtp_cardForm__x1ned","doctor":"CardOtp_doctor__A57Ro"};